<template>
  <div class="row">
    <b-modal
      size="xl"
      id="modal-associar"
      @ok="salvar"
      :ok-only="modal == 'novo'"
      :ok-title="modal == 'novo' ? 'Fechar' : 'Salvar'"
      :ok-variant="modal == 'novo' ? 'primary' : 'success'"
      :title="titulo"
      class=""
    >
      <component :is="modal" ref="formulario" @salvo="fecharModal"></component>
    </b-modal>
    <b-card class="col-12" no-body>
      <div class="row">
        <div class="col-12 mb-3 d-flex">
          <b-button
            variant="primary"
            @click="create"
            v-if="this.endpoint == 'Projeto' && permissao.c"
            >Associar proposta</b-button
          >
          <b-button
            class="ml-2"
            variant="info"
            @click="importar"
            v-if="
              this.endpoint == 'Projeto' &&
              permissao.c &&
              this.$store.state.app.selectedCompanyObj.tipo !== 'Executora'
            "
            >Importar XML</b-button
          >
        </div>
        <b-form class="col-12" @submit="onSearch">
          <div class="row">
            <filtro-empresas
              class="col-12 col-md-4"
              v-if="ehAdmin"
              @update="fetch()"
            />
            <input-text
              :class="`col-12 col-md-${ehAdmin ? 8 : 12}`"
              label="Filtrar"
              placeholder="Digite o título para buscar..."
              v-model="filter"
            >
              <template #append>
                <b-button variant="primary" class="ml-2" type="submit"
                  >Buscar</b-button
                >
              </template>
            </input-text>
          </div>
        </b-form>
        <div class="col-12">
          <b-table
            id="table"
            @row-dblclicked="open"
            head-variant="dark"
            hover
            :items="table.items"
            :fields="table.fields"
          >
            <template #cell(col1)="data">
              <div class="row">
                <b-badge pill class="px-2 py-1 mb-2" variant="info">
                  {{
                    retornarStatus(
                      data.item.proposta && data.item.proposta.aprovada
                        ? data.item[status]
                        : data.item.proposta[status]
                    )
                  }}
                </b-badge>

                <Label
                  class="col-12"
                  label="Código do projeto:"
                  :value="data.item.codigo"
                  icon="vpn_key"
                />
                <Label
                  class="col-12"
                  label="Titulo:"
                  :value="data.item.proposta.descricaoTecnica.titulo"
                  icon="title"
                />
                <Label
                  class="col-12"
                  label="Apelido:"
                  :value="data.item.proposta.descricaoTecnica.apelido"
                  icon="subtitles"
                />

                <div class="col-12 col-md-6">
                  <div class="row">
                    <Label
                      class="col-12"
                      label="Fase de inovação:"
                      :value="
                        (options.fases.find(
                          (el) =>
                            el.value ==
                            data.item.proposta.descricaoTecnica.faseDeInovacao
                        ) || {}).text || ''
                      "
                      icon="checklist_rtl"
                    />
                    <Label
                      class="col-12"
                      label="Tipo de produto:"
                      :value="
                        options.tipoProdutos.find(
                          (el) =>
                            el.value ==
                            data.item.proposta.descricaoTecnica.tipoProduto
                        ).text || ''
                      "
                      icon="category"
                    />
                    <Label
                      class="col-12"
                      label="Data de inicio:"
                      v-if="data.item.dataInicio"
                      :value="data.item.dataInicio"
                      icon="calendar_month"
                    />
                    <Label
                      class="col-12"
                      label="Data de termino:"
                      v-if="data.item.dataInicio"
                      :value="data.item.dataTermino"
                      icon="calendar_month"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="row">
                    <Label
                      class="col-12"
                      label="Segmento:"
                      :value="
                        options.segmentos.find(
                          (el) =>
                            el.value ==
                            data.item.proposta.descricaoTecnica.segmento
                        ).text || ''
                      "
                      icon="segment"
                    />
                    <Label
                      class="col-12"
                      label="Tema:"
                      :value="
                        data.item.proposta.descricaoTecnica.temaSelecionado.tema
                          .nome
                      "
                      icon="bookmark"
                    />
                    <Label
                      class="col-12"
                      label="Duração:"
                      :value="data.item.duracao"
                      v-if="!data.item.duracaoAntiga"
                      icon="timer"
                    />
                    <Label
                      class="col-12"
                      label="Duração prevista:"
                      :value="data.item.duracaoAntiga"
                      v-if="data.item.duracaoAntiga"
                      icon="timer"
                    />
                    <Label
                      class="col-12"
                      label="Nova duração:"
                      :value="data.item.duracao"
                      v-if="data.item.duracaoAntiga"
                      icon="timer"
                    />
                    <Label
                      class="col-12"
                      label="Mês de execução:"
                      v-if="data.item.dataInicio"
                      :value="calcularMesExecucao(data.item)"
                      icon="calendar_month"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template #cell(actions)="data">
              <div class="d-flex">
                <b-button variant="flat-primary" @click="open(data.item)">
                  <i class="fas fa-edit"></i>
                </b-button>
                <b-button
                  v-if="permissao.r"
                  variant="flat-danger"
                  @click="excluirProjeto(data.item)"
                >
                  <i class="fa-solid fa-trash"></i>
                </b-button>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="table.currentPage"
            :total-rows="table.dataLength"
            :per-page="ehAdmin ? 40 : table.perPage"
            @change="updatePagination"
            align="center"
          ></b-pagination>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";

import Label from "@/components/inputs/Label";

import Segmento from "@/common/mock/Segmento.json";
import TipoProduto from "@/common/mock/TipoProduto.json";

import ProjetoService from "@/common/services/projeto/projeto.service";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

import helpers from "@/common/utils/helpers";
import moment from "moment";

export default {
  name: "PropostaList",
  components: {
    InputText,
    Label,
    novo: () => import("./ProjetoForm"),
    importar: () => import("./ProjetoImportaXML"),
  },
  props: {
    endpoint: {
      type: String,
      default: "Projeto",
    },
    texto: {
      type: String,
    },
  },
  data: () => ({
    table: {
      fields: [
        { key: "col1", label: "Projetos" },
        { key: "col2", label: "" },
        { key: "actions", label: "Ações" },
      ],
      items: [],
      perPage: 10,
      currentPage: 1,
      dataLength: 0,
    },

    empresas: [],

    options: {
      segmentos: Segmento,
      fases: helpers.FaseInovacao,
      tipoProdutos: TipoProduto,
    },
    filter: "",
    modal: "",
    titulo: "",
    empresaSelecionada: null,
  }),
  methods: {
    calcularMesExecucao(projeto) {
      if (!projeto.dataInicio) return "";
      let dataInicio = moment(projeto.dataInicio, "DD/MM/YYYY");
      let dataAtual = moment();
      var duracao = moment.duration(dataAtual.diff(dataInicio));
      let meses = parseInt(duracao.asMonths()) + 1;
      return `Mês ${meses}`;
    },
    retornarStatus: function (status) {
      return helpers.getEnum(status).text;
    },
    salvar: function (e) {
      if (this.modal == "importar") {
        e.preventDefault();
        this.$refs.formulario.salvar();
      }
    },
    excluirProjeto: function (item) {
      this.confirmar(
        `Deseja seguir com a exclusão do projeto?
        Todos os dados realizados serão deletados.`
      ).then((confirmado) => {
        if (!confirmado) return;

        ProjetoService.apagar(item.id)
          .then(() => {
            this.alertaSucesso(`Projeto excluído com sucesso!`).then(() =>
              this.fetch()
            );
          })
          .catch(() => {
            this.alertaErro(`Erro ao excluir projeto!`);
          });
      });
    },
    open: function (item) {
      ProjetoService.setEndpoint(item.endpoint);
      switch (item.endpoint) {
        case "Projeto":
          this.$router.push({
            name: "projeto-detalhamento",
            params: { id: item.id },
          });
          break;
        case "ProjetoEmpresaExecutoraCriadora":
          this.$router.push({
            name: "projeto-detalhamento-executora-criadora",
            params: { id: item.id },
          });
          break;
        case "ProjetoEmpresaExecutora":
          this.$router.push({
            name: "projeto-detalhamento-executora-associada",
            params: { id: item.id },
          });
          break;
        case "ProjetoEmpresaCooperada":
          this.$router.push({
            name: "projeto-detalhamento-proponente-cooperada",
            params: { id: item.id },
          });
          break;
      }
    },
    create: function () {
      this.titulo = "Propostas disponíveis para associação";
      this.modal = "novo";
      this.$bvModal.show("modal-associar");
    },
    importar: function () {
      this.titulo = "Criar projeto a partir de um arquivo XML";
      this.modal = "importar";
      this.$bvModal.show("modal-associar");
    },
    fecharModal: function () {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-associar");
      });
      this.fetch();
    },
    onSearch: function (e) {
      e.preventDefault();
      this.table.currentPage = 1;
      this.fetch(this.filter);
    },
    updatePagination: function (page) {
      this.fetch(this.filter, page - 1);
    },
    fetch: function (filter = "", page = 0) {
      if (!this.empresaSelecionada) return;

      this.table.items = [];
      this.table.dataLength = 0;

      const parametros = [
        this.empresaSelecionada,
        filter,
        this.table.perPage,
        page,
      ];

      ProjetoService.listarAgrupados(...parametros).then((res) => {
        this.table.items = [];
        this.table.dataLength = res.data.data.paginacao.totalDeElementos;

        this.table.items = res.data.data.itens.map((el) => {
          let id = el.id;
          let endpoint = el.endpoint;

          let newEl = el.projeto;
          newEl.id = id;
          newEl.endpoint = endpoint;

          if (newEl.dataInicio) {
            newEl.dataTermino = helpers.formatarDataBr(
              helpers.adicionarValorData(newEl.dataInicio, newEl.duracao, "M")
            );
            newEl.dataInicio = helpers.formatarDataBr(newEl.dataInicio);
          }

          return newEl;
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.texto }]);
    //this.fetch();
  },
  watch: {
    endpoint: function () {
      this.fetch();
    },
    texto: function () {
      this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.texto }]);
    },
    "$store.state.app.selectedCompanyObj": {
      handler(newSelectedCompanyObj) {
        this.empresaSelecionada = newSelectedCompanyObj
          ? newSelectedCompanyObj.id
          : null;
        this.fetch();
      },
      immediate: true,
    },
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("ProjetosPd");
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    status() {
      switch (this.endpoint) {
        case "Projeto":
          return "statusProponente";
        case "ProjetoEmpresaExecutoraCriadora":
          return "statusExecutora";
        case "ProjetoEmpresaExecutora":
          return "statusExecutora";
        case "ProjetoEmpresaCooperada":
          return "statusProponente";
      }

      return "";
    },
  },
};
</script>
<style lang=""></style>
